module.exports = __webpack_public_path__ + "static/media/video_thumb4.33223d0f.png";